import { fetchMemberRoleInfo, ROLE_TYPE_ENUM, MerchantType, KolType, MerchantResponse, KolResponse } from '@/api/fetchKOLOrMerchantInfo'
import { useQuery } from 'react-query'
import { QUERY_KEY } from '@/constants/queryKey'
import { useUserProfile } from './useUserProfile'
import { ROLE_TYPE } from '@/constants/roleType'

type UseMemberRoleInfo = {
  kolInfo?: KolType
  merchantInfo?: MerchantType
  refetchMerchantInfo: () => void
  refetchKOLInfo: () => void
  refetchRoleInfo: () => void
}

export const useMemberRoleInfo = ({ memberInfoId }: { memberInfoId: string }): UseMemberRoleInfo => {
  const { userProfile } = useUserProfile({ memberInfoId })
  const { roleDetail } = userProfile || {}
  const KOLId = roleDetail?.[ROLE_TYPE.KOL]?.id
  const merchantId = roleDetail?.[ROLE_TYPE.MERCHANT]?.id
  const canFetchKOLInfo = !!KOLId
  const canFetchMerchantInfo = !!merchantId

  const { data: KOLRoleInfo, refetch: refetchKOLInfo } = useQuery(
    [QUERY_KEY.FETCH_MEMBER_ROLE_INFO, { KOLId }],
    () => fetchMemberRoleInfo({ role: ROLE_TYPE_ENUM.KOL, roleId: KOLId }),
    {
      enabled: canFetchKOLInfo,
    },
  )
  const refetchRoleInfo = () => {
    if (canFetchKOLInfo) {
      refetchKOLInfo()
    }
    if (canFetchMerchantInfo) {
      refetchMerchantInfo()
    }
  }

  const { data: merchantRoleInfo, refetch: refetchMerchantInfo } = useQuery(
    [QUERY_KEY.FETCH_MEMBER_ROLE_INFO, { merchantId }],
    () => fetchMemberRoleInfo({ role: ROLE_TYPE_ENUM.MERCHANT, roleId: merchantId }),
    {
      enabled: canFetchMerchantInfo,
    },
  )

  return {
    kolInfo: (KOLRoleInfo as KolResponse)?.kol,
    merchantInfo: (merchantRoleInfo as MerchantResponse)?.merchant,
    refetchMerchantInfo,
    refetchKOLInfo,
    refetchRoleInfo,
  }
}
